import * as React from 'react';
import { observer } from 'mobx-react';

export interface CalendarConflictGroupItemProps {
    content: () => JSX.Element[];
}

@observer
export default class CalendarConflictGroupItem extends React.Component<
    CalendarConflictGroupItemProps,
    {}
> {
    render() {
        return this.props.content();
    }
}
